export default "__VITE_ASSET__BiUpT1x4__"